import { format, isValid } from 'date-fns';
import { cs } from 'date-fns/locale';
const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy';
export const formatDateToInputValue = (date) => {
    const isValidDate = date && isValid(date);
    if (!isValidDate)
        return '';
    const formattedDate = format(date, DISPLAY_DATE_FORMAT, { locale: cs });
    return formattedDate;
};
